// extracted by mini-css-extract-plugin
export default {"info":"EmailChangeModal_info__N+ysw"};